import { render, staticRenderFns } from "./wizzardCajav5.vue?vue&type=template&id=6c02fb10&scoped=true"
import script from "./wizzardCajav5.vue?vue&type=script&lang=js"
export * from "./wizzardCajav5.vue?vue&type=script&lang=js"
import style0 from "./wizzardCajav5.vue?vue&type=style&index=0&id=6c02fb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02fb10",
  null
  
)

export default component.exports